import { useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";

import "./notesModal.css";

function TreatmentDescriptionNoteModal({ show, handleClose, onSave, initialDescription = "" }) {
  const [treatmentDescription, setTreatmentDescription] = useState(initialDescription || "");
  const [descriptionTouched, setDescriptionTouched] = useState(false);
  const [note, setNote] = useState("");
  const [saving, setSaving] = useState(false);
  const [, setError] = useState("");
  const hasChanges = treatmentDescription !== (initialDescription || "") || Boolean(note.trim());

  useEffect(() => {
    if (!descriptionTouched) setTreatmentDescription(initialDescription || "");
  }, [initialDescription, descriptionTouched]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!hasChanges || saving) return;

    setSaving(true);
    setError("");
    try {
      await onSave({ treatmentDescription, note: note.trim() });
      handleClose();
    } catch (saveError) {
      setError(saveError?.response?.data?.detail || "Unable to save treatment. Please try again.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="treatment-description-note-dialog treatment-notes-modal"
    >
      <Modal.Header className="tfbp-modal-header">
        <Modal.Title className="tfbp-modal-title text-uppercase">
          Edit Treatment Description and Add Note
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body className="treatment-notes-modal-body">
          <Form.Group controlId="treatment-description" className="m-b-5">
            <Form.Label className="treatment-notes-field-label">Treatment Description</Form.Label>

            <Form.Control
              as="textarea"
              rows={3}
              value={treatmentDescription}
              onChange={(event) => {
                setDescriptionTouched(true);
                setTreatmentDescription(event.target.value);
              }}
            />
          </Form.Group>
          <Form.Group controlId="new-treatment-note" className="mb-0">
            <Form.Label className="treatment-notes-field-label">New Treatment Note</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={note}
              onChange={(event) => setNote(event.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="treatment-notes-modal-footer">
          <Button
            variant="secondary"
            type="button"
            className="height-25 d-flex align-items-center justify-content-center"
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            variant="success"
            type="submit"
            className="height-25 d-flex align-items-center justify-content-center"
            disabled={!hasChanges || saving}
          >
            {saving ? "Saving..." : "Save and Close"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default TreatmentDescriptionNoteModal;
